
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ValidationError,
} from '../models';
import {
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface SuggestSkillsRequest {
    jobTitle: string;
    category: string;
    skills?: Array<string>;
}

/**
 * 
 */
export class SuggestSkillsApi extends runtime.BaseAPI {

    /**
     * Suggest skills
          */
    async suggestSkillsRaw(requestParameters: SuggestSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<string>>> {
        if (requestParameters['jobTitle'] == null) {
            throw new runtime.RequiredError(
                'jobTitle',
                'Required parameter "jobTitle" was null or undefined when calling suggestSkills().'
            );
        }

        if (requestParameters['category'] == null) {
            throw new runtime.RequiredError(
                'category',
                'Required parameter "category" was null or undefined when calling suggestSkills().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['jobTitle'] != null) {
            queryParameters['jobTitle'] = requestParameters['jobTitle'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['category'] = requestParameters['category'];
        }

        if (requestParameters['skills'] != null) {
            queryParameters['skills'] = requestParameters['skills'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<string>>({
            path: `/search/api/skills/suggestions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Suggest skills
          */
    async suggestSkills(requestParameters: SuggestSkillsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.suggestSkillsRaw(requestParameters, initOverrides);
        return response._data;
    }

}
